/**
 * Environment-aware logging utility.
 * In development: passes through to console.
 * In production: suppresses log/debug/warn, keeps error.
 */

const isDev = process.env.NODE_ENV === 'development';

/* eslint-disable no-console */
export const logger = {
  log: (...args: unknown[]): void => {
    if (isDev) console.log(...args);
  },
  debug: (...args: unknown[]): void => {
    if (isDev) console.debug(...args);
  },
  warn: (...args: unknown[]): void => {
    if (isDev) console.warn(...args);
  },
  error: (...args: unknown[]): void => {
    // Always log errors, even in production
    console.error(...args);
  },
  info: (...args: unknown[]): void => {
    if (isDev) console.info(...args);
  },
};
/* eslint-enable no-console */

export default logger;
